// useNavigationPrompt.js
import { useContext, useEffect, useRef } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export const usePrompt = (when, onNavigateAttempt) => {
  const navigator = useContext(NavigationContext).navigator;
  const lastAttempt = useRef(null);

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;

    navigator.push = (...args) => {
      lastAttempt.current = () => originalPush(...args);
      onNavigateAttempt(); // trigger modal
    };

    navigator.replace = (...args) => {
      lastAttempt.current = () => originalReplace(...args);
      onNavigateAttempt();
    };

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [navigator, when, onNavigateAttempt]);

  const confirmNavigation = () => {
    if (lastAttempt.current) {
      lastAttempt.current();
    }
  };

  return { confirmNavigation };
};
